import React, { FunctionComponent } from "react";

const LabFlaskExperimentIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/science/labs-experiments/lab-flask-experiment
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.25 -0.25 24.5 24.5">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.72601 0.75H17.226"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.726 8.25V0.75H8.22603V8.25L1.48903 18.615C1.1949 19.0675 1.02828 19.5909 1.00673 20.1302C0.985172 20.6694 1.10948 21.2045 1.36655 21.679C1.62362 22.1535 2.00393 22.5499 2.4674 22.8264C2.93088 23.1029 3.46035 23.2492 4.00003 23.25H19.948C20.488 23.2499 21.018 23.1041 21.4821 22.8279C21.9461 22.5517 22.327 22.1554 22.5846 21.6808C22.8421 21.2061 22.9668 20.6708 22.9454 20.1312C22.924 19.5916 22.7573 19.0678 22.463 18.615L15.726 8.25Z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.30103 12.75H18.651"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.226 17.25H17.226"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.726 15.75V18.75"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.726 3.75H12.726"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.726 6.75H12.726"
      ></path>
      <path
        stroke="currentColor"
        d="M6.72601 19.875C6.51891 19.875 6.35101 19.7071 6.35101 19.5C6.35101 19.2929 6.51891 19.125 6.72601 19.125"
      ></path>
      <path
        stroke="currentColor"
        d="M6.72601 19.875C6.93312 19.875 7.10101 19.7071 7.10101 19.5C7.10101 19.2929 6.93312 19.125 6.72601 19.125"
      ></path>
      <g>
        <path
          stroke="currentColor"
          d="M9.72601 16.875C9.51891 16.875 9.35101 16.7071 9.35101 16.5C9.35101 16.2929 9.51891 16.125 9.72601 16.125"
        ></path>
        <path
          stroke="currentColor"
          d="M9.72601 16.875C9.93312 16.875 10.101 16.7071 10.101 16.5C10.101 16.2929 9.93312 16.125 9.72601 16.125"
        ></path>
      </g>
    </svg>
  );
};

export default LabFlaskExperimentIcon;
